import React from "react";
import { Link } from "react-router-dom";
import { XCircle, ArrowLeft, RefreshCw } from "lucide-react";
import { useLanguage } from "../contexts/LanguageContext";

const PaymentCancel: React.FC = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen pt-24 pb-12 bg-gray-50 flex items-center">
      <div className="container-custom">
        <div className="max-w-lg mx-auto text-center">
          {/* Cancel Icon */}
          <div className="w-24 h-24 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <XCircle className="w-14 h-14 text-romanian-red" />
          </div>

          {/* Title */}
          <h1 className="font-display text-3xl font-bold text-gray-900 mb-4">
            {t.paymentCancel.title}
          </h1>

          {/* Description */}
          <p className="text-gray-600 mb-8">{t.paymentCancel.description}</p>

          {/* Actions */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/acces"
              className="btn-primary flex items-center space-x-2"
            >
              <RefreshCw className="w-5 h-5" />
              <span>{t.paymentCancel.tryAgain}</span>
            </Link>
            <Link to="/" className="btn-outline flex items-center space-x-2">
              <ArrowLeft className="w-5 h-5" />
              <span>{t.paymentSuccess.backHome}</span>
            </Link>
          </div>

          {/* Help */}
          <div className="mt-12 p-6 bg-white rounded-xl shadow-md">
            <h3 className="font-semibold text-gray-900 mb-2">
              {t.common.needHelp}
            </h3>
            <p className="text-gray-600 text-sm mb-4">
              {t.common.helpDescription}
            </p>
            <Link
              to="/contact"
              className="text-romanian-blue font-semibold hover:underline"
            >
              {t.common.goToContact} →
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
